/**
 * @module Theme
 */

import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ChartType } from '@models/chart.model';
import { ThemeOptionType } from '@models/themeStudio.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-theme-option-datalabels-background-color-detail',
  templateUrl: './theme-option-datalabels-background-color-detail.component.html',
  styleUrls: ['./theme-option-datalabels-background-color-detail.component.css']
})
export class ThemeOptionDatalabelsBackgroundColorDetailComponent implements OnInit, OnDestroy {

  @Input() themeOptions: ThemeOptionsClass;
  @Input() datalabelsIndex: number;
  @Input() type: ChartType;

  color = ItemColor('themes');
  opacity: number;
  backgroundColor: string;
  changedSeries$sub: Subscription;
  optionType: ThemeOptionType = 'datalabels_backgroundColor';

  constructor() {}

  ngOnInit() {
    this.setAttributes();

    this.changedSeries$sub = this.themeOptions.changedSeries$.subscribe({
      next:(option: ThemeOptionType) => {
        if(option === this.optionType) {
          this.setAttributes();
        }
      }
    });
  }

  ngOnDestroy() {
    this.changedSeries$sub.unsubscribe();
  }

  setAttributes() {
    this.backgroundColor = this.themeOptions.datalabels(this.datalabelsIndex, this.type).backgroundColor.toString().slice(0, 7);
    this.opacity = Math.round(parseInt(this.themeOptions.datalabels(this.datalabelsIndex, this.type).backgroundColor.toString().slice(7, 9), 16) * 100 / 255);
  }
  
  receiveValue(value: string) {
    this.backgroundColor = value;
    this.themeOptions.setDatalabels(this.optionType, value + Math.round(this.opacity * 255 / 100).toString(16), this.datalabelsIndex, [this.type]);
  }

  receiveOpacity(value: number) {
    this.opacity = value;
    if(this.opacity > 0) this.themeOptions.setDatalabels(this.optionType, this.backgroundColor + Math.round(value * 255 / 100).toString(16), this.datalabelsIndex, [this.type]);
    else this.themeOptions.setDatalabels(this.optionType, this.backgroundColor + '00', this.datalabelsIndex, [this.type]);
  }

}
